import React, { useEffect } from "react";
import "./styles.scss"

function ReservationPopup({ selectedRoom, closePopup, selectedRoomUserData, showForm }) {

    useEffect(() => {
        console.log(selectedRoomUserData)
    }, [])

    return (
        <div className="reservation-popup-root">
            <div className="reservation-popup">
                <svg viewBox="0,0,256,256" width="24px" height="24px" fill-rule="nonzero" className="cross" onClick={closePopup}><g fill="#5b2706">
                    <g transform="scale(10.66667,10.66667)">
                        <path d="M4.99023,3.99023c-0.40692,0.00011 -0.77321,0.24676 -0.92633,0.62377c-0.15312,0.37701 -0.06255,0.80921 0.22907,1.09303l6.29297,6.29297l-6.29297,6.29297c-0.26124,0.25082 -0.36647,0.62327 -0.27511,0.97371c0.09136,0.35044 0.36503,0.62411 0.71547,0.71547c0.35044,0.09136 0.72289,-0.01388 0.97371,-0.27511l6.29297,-6.29297l6.29297,6.29297c0.25082,0.26124 0.62327,0.36648 0.97371,0.27512c0.35044,-0.09136 0.62411,-0.36503 0.71547,-0.71547c0.09136,-0.35044 -0.01388,-0.72289 -0.27512,-0.97371l-6.29297,-6.29297l6.29297,-6.29297c0.29576,-0.28749 0.38469,-0.72707 0.22393,-1.10691c-0.16075,-0.37985 -0.53821,-0.62204 -0.9505,-0.60988c-0.2598,0.00774 -0.50638,0.11632 -0.6875,0.30273l-6.29297,6.29297l-6.29297,-6.29297c-0.18827,-0.19353 -0.4468,-0.30272 -0.7168,-0.30273z">
                        </path>
                    </g>
                </g>
                </svg>
                <img className="room-image" src={`https://mhreserve.com/wp-content/uploads/reserve/assets/rooms/webp/${selectedRoomUserData.roomType}.webp`} />
                <div className="reserve-button" onClick={() => { closePopup(); showForm() }}>Reserve</div>
                {/* {`Reserving Room No: ${selectedRoom} on ${floor} floor...`} */}
            </div>
        </div>
    )
}

export default ReservationPopup